/**
 * Product Tabs Component
 * Handles tab switching functionality with keyboard navigation support
 * Works with any number of tabs dynamically
 */

class ProductTabs {
  constructor(element) {
    this.element = element;
    this.buttons = element.querySelectorAll('[role="tab"]');
    this.panels = element.querySelectorAll('[role="tabpanel"]');

    if (this.buttons.length === 0) return; // No tabs to initialize

    this.init();
  }

  init() {
    this.buttons.forEach((button, index) => {
      button.addEventListener("click", () => this.selectTab(button));
      button.addEventListener("keydown", (e) => this.handleKeyboard(e, index));
    });
  }

  selectTab(button) {
    const tabId = button.getAttribute("aria-controls");

    // Remove active state from all buttons and panels
    this.buttons.forEach((btn) => {
      btn.classList.remove("product-tabs__button--active");
      btn.setAttribute("aria-selected", "false");
    });

    this.panels.forEach((panel) => {
      panel.classList.remove("product-tabs__panel--active");
    });

    // Add active state to clicked button and corresponding panel
    button.classList.add("product-tabs__button--active");
    button.setAttribute("aria-selected", "true");

    const panel = this.element.querySelector(`#${tabId}`);
    if (panel) {
      panel.classList.add("product-tabs__panel--active");
    }
  }

  handleKeyboard(event, index) {
    let targetIndex = index;

    switch (event.key) {
      case "ArrowLeft":
      case "ArrowUp":
        event.preventDefault();
        targetIndex = (index - 1 + this.buttons.length) % this.buttons.length;
        this.buttons[targetIndex].focus();
        this.selectTab(this.buttons[targetIndex]);
        break;

      case "ArrowRight":
      case "ArrowDown":
        event.preventDefault();
        targetIndex = (index + 1) % this.buttons.length;
        this.buttons[targetIndex].focus();
        this.selectTab(this.buttons[targetIndex]);
        break;

      case "Home":
        event.preventDefault();
        this.buttons[0].focus();
        this.selectTab(this.buttons[0]);
        break;

      case "End":
        event.preventDefault();
        this.buttons[this.buttons.length - 1].focus();
        this.selectTab(this.buttons[this.buttons.length - 1]);
        break;
    }
  }
}

// Initialize tabs on page load
document.addEventListener("DOMContentLoaded", () => {
  const tabContainers = document.querySelectorAll(
    '[data-component="product-tabs"]',
  );
  tabContainers.forEach((container) => {
    new ProductTabs(container);
  });
});

// Handle dynamically added tabs
if (window.MutationObserver) {
  const observer = new MutationObserver(() => {
    const uninitializedTabs = document.querySelectorAll(
      '[data-component="product-tabs"]:not([data-initialized])',
    );
    uninitializedTabs.forEach((container) => {
      new ProductTabs(container);
      container.setAttribute("data-initialized", "true");
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
